module.exports = __webpack_public_path__ + "img/ic_mangguodianzhang_logo_normal.0dfbb72.png";